export enum ContactUsActionTypes {
  CREATE_SUPPORT_MESSAGE = "@@CONTACT_US/CREATE_SUPPORT_MESSAGE",
  CREATE_SUPPORT_MESSAGE_SUCCESS = "@@CONTACT_US/CREATE_SUPPORT_MESSAGE_SUCCESS",
  CREATE_SUPPORT_MESSAGE_FAILURE = "@@CONTACT_US/CREATE_SUPPORT_MESSAGE_FAILURE",
}
